<template>
  <v-container fluid>
    <v-layout justify-center align-top row wrap text-xs-center>
      <v-flex xs12 text-xs-left block>
        Внимательно прочитайте инструкцию. Если возникнут вопросы, то обращайтесь, всегда рады вам помочь :)
      </v-flex>
      <v-flex xs12 title block>Смс провайдер</v-flex>
      <v-flex xs12 text-xs-left block>
        Вам необходимо иметь личный кабинет у одного из смс-провайдеров.
        Сейчас приложение работает с <a href="https://rocketsms.by/?refid=RSD2YN7R" target="blank">RocketSMS</a> и <a href="https://imobis.ru/" target="blank">Imobis</a>.
        По ссылкам вы можете зарегистрироваться у одного из них. Также через службу поддержки смс-провайдера необходимо зарегистрировать альфа-имя (имя которое будет видеть получатель смс-сообщения).
      </v-flex>

      <v-flex xs12 title block>Yclients</v-flex>
      <v-flex xs12 text-xs-left block>
        Для работы с приложением вам понадобится API-ключ. Для того чтобы получить API-ключ вам надо написать письмо в поддержку Yclients (support@yclients.com). В течение дня придет ответ с ключом.<br>
      </v-flex>
      <v-flex xs12 text-xs-left block><b>Тема</b></v-flex>
      <v-flex xs12 text-xs-left block>API-ключ для интеграции</v-flex>
      <v-flex xs12 text-xs-left block><b>Текст письма</b></v-flex>
      <v-flex xs12 text-xs-left block>
        Добрый день, хочу получить API token для кастомной интеграции<br>

        Кейсы для интеграции<br>
        а) Получить список всех записей на завтра<br>
        б) Настроить синхронизацию с клиентской базой<br><br>

        -Контакты разработчика<br>
        Алексей<br>
        +375 29 2988472<br>
        kastrulin@gmail.com<br>

        -Идентификатор филиала<br>
        %%%ваш идентификатор, посмотрите в разделе Обзор - Сводка.%%%<br>
      </v-flex>
      <v-flex xs12 text-xs-left block>
        <br>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data () {
    return {}
  },
  created () {
    this.$store.commit('showNavigation')
  }
}
</script>

<style>
  .block {
    margin-bottom: 10px;
  }
</style>
